// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"f19b6fdec5039c0abd28","418":"f3f3a37a87cd19cc6752","661":"e32c267f6dcca064ef53"}[chunkId] + ".bundle.js";
};